/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnalyticsGeneralInfo } from '../models/AnalyticsGeneralInfo';
import type { ChartListInfo } from '../models/ChartListInfo';
import type { MetricInfo } from '../models/MetricInfo';
import type { MetricListInfo } from '../models/MetricListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AnalyticsControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getValuationRot({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/valuation/rot',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getValuationPsr({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/valuation/psr',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getValuationMarketCapPerTvl({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/valuation/marketcap-per-tvl',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getValuationMarketCapPerTransaction({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/valuation/marketcap-per-transaction',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getUserUniqueAddresses({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/unique-addresses',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getUserNewAddresses({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/new-addresses',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getUserActiveAddresses({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/active-addresses',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTransactionGasTransactionFees({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/transaction-gas/transaction-fees',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns MetricListInfo OK
     * @throws ApiError
     */
    public getTransactionGasTopGasSpenders({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY',
    }): CancelablePromise<MetricListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/transaction-gas/top-gas-spenders',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTransactionGasGasUsed({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/transaction-gas/gas-used',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTransactionGasAverageGasPrice({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/transaction-gas/average-gas-price',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenNumberOfTransfer({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/transfer',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenTradingVolume({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/trading-volume',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenPrice1({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/price',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenMarketCap({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/marketcap',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenHolder({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/holder',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenHolderRatio({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/holder-ratio',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenCirculatingSupply({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/circulating-supply',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTokenBurned({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/burned',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getRevenueFeeRevenue({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/revenue/fee-revenue',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getNetworkTvl({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/tvl',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getNetworkTransaction({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/transaction',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getTransactionPerSec({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/tps',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns MetricListInfo OK
     * @throws ApiError
     */
    public getNetworkTopBurners({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY',
    }): CancelablePromise<MetricListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/top-burners',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getFunctionCallCount({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/contract-call',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getNetworkBurned({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/burned',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getBlockInterval({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/block-interval',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getBlockCreation({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/block-creation',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns ChartListInfo OK
     * @throws ApiError
     */
    public getAverageTransactionPerAddress({
        period = 'DAILY',
    }: {
        period?: 'DAILY' | 'WEEKLY' | 'MONTHLY',
    }): CancelablePromise<ChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/avg-trx-address',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns MetricInfo OK
     * @throws ApiError
     */
    public getKeyMarketIndicator(): CancelablePromise<Array<MetricInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/key-market-indicator',
        });
    }

    /**
     * @returns AnalyticsGeneralInfo OK
     * @throws ApiError
     */
    public getAnalyticsGeneral({
        types,
    }: {
        types: string,
    }): CancelablePromise<AnalyticsGeneralInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/general',
            query: {
                'types': types,
            },
        });
    }

}
